export default "__VITE_ASSET__C9etAG93__"